import React, { createContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

interface IMenuContext {
  isOpen: boolean;
  toggleMenu: () => void;
  currentPage: string;
}

const MenuContext = createContext<IMenuContext>({} as IMenuContext);

export const MenuContextProvider: React.FC = ({ children }) => {
  const location = useLocation();

  const [isOpen, setIsOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(location.pathname);

  useEffect(() => {
    setCurrentPage(location.pathname);
  }, [location.pathname]);

  function toggleMenu() {
    setIsOpen(prev => !prev);
  }

  return (
    <MenuContext.Provider
      value={{
        isOpen,
        toggleMenu,
        currentPage
      }}
    >
      {children}
    </MenuContext.Provider>
  );
};

export default MenuContext;
